/**
 * 컬렉션 표시명 — 기본 컬렉션만 화면이 이름을 갈아 끼운다.
 *
 * 서버는 기본 컬렉션을 한국어 '즐겨찾기' 로 만든다. 만드는 주체가 목록 조회라 그 시점에
 * 회원의 표시 언어를 알 수 없고, 기본 컬렉션은 이름 변경이 막혀 있어(FN-084) 나중에
 * 고쳐 줄 수도 없다. 그래서 **저장된 이름이 아니라 화면이** 언어를 맞춘다.
 *
 * ⚠ 기본 컬렉션에만 적용한다. 사용자가 지은 이름은 번역 대상이 아니다 — 무엇을 번역할지
 *   판단하려 들면 '즐겨찾기' 라고 직접 지은 컬렉션까지 언어를 따라 바뀐다.
 */
import type { TFunction } from "i18next";

export function collectionGroupName(
  group: { name: string; defaultGroup: boolean },
  t: TFunction,
): string {
  return group.defaultGroup ? t("collection.defaultName") : group.name;
}
